import { Link } from "react-router-dom";
import { useSeo } from "@/lib/useSeo";
import { IMG } from "@/lib/images";
import { PageHeader, Section, Prose, Quote } from "@/components/Editorial";

const THEMES = ["absence", "manque", "culpabilité", "colère", "tristesse", "souvenirs", "objets", "voix", "signes", "anniversaires", "lien continu", "rire", "émotions contradictoires"];

export default function Deuil() {
  useSeo({
    title: "Deuil",
    description: "Le deuil abordé avec justesse par Dorothée Lancelot : l'absence, le manque, les souvenirs, les signes et le lien qui continue. En lien avec l'association AAESAD.",
    path: "/deuil",
    keywords: ["accompagnement du deuil", "aide au deuil", "perte d'un proche", "surmonter le deuil", "faire son deuil", "soutien deuil", "café-deuil", "AAESAD", "deuil d'un enfant", "deuil d'un parent"],
  });

  return (
    <div>
      <PageHeader
        eyebrow="Page éditoriale"
        title="Deuil"
        intro="Parler du deuil sans être morbide : l'absence et le manque, mais aussi les souvenirs, le rire, les émotions contradictoires et le lien qui continue."
        image={IMG.highlands}
      />
      <Section>
        <Prose>
          <p>
            Le deuil n'avance pas en ligne droite. Il mêle la tristesse et la colère, la culpabilité et la
            tendresse, le silence et parfois le rire. Chaque personne le traverse à son rythme, avec ses objets,
            ses dates, ses signes et sa manière de garder le lien.
          </p>
        </Prose>

        <Quote>« La colère aide à exprimer le trop-plein ; la tristesse, elle, garde la douleur. »</Quote>

        <div className="mt-10 flex flex-wrap gap-2.5">
          {THEMES.map((t, i) => (
            <span key={i} className="px-4 py-2 text-sm border border-[rgba(198,167,106,0.25)] text-[#F3E9D2]/75">{t}</span>
          ))}
        </div>

        <div className="mt-14 flex flex-wrap gap-4">
          <Link to="/aaesad" className="dl-btn dl-btn-solid">L'association AAESAD</Link>
          <Link to="/livres" className="dl-btn">Deuil et signes de l'au-delà</Link>
        </div>
      </Section>
    </div>
  );
}
